import { render, staticRenderFns } from "./CreateClinic.vue?vue&type=template&id=03a51f80&scoped=true"
import script from "./CreateClinic.vue?vue&type=script&lang=js"
export * from "./CreateClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a51f80",
  null
  
)

export default component.exports